import ErrorCrossIconSvg from "../../assets/images/error-cross-icon.svg";
import { ErrorCrossIconWrapper } from "./ErrorCrossIcon.style";

interface ErrorCrossIconProps {
  className?: string;
}

export const ErrorCrossIcon: React.FC<ErrorCrossIconProps> = ({
  className = "",
}) => {
  return (
    <ErrorCrossIconWrapper
      className={className}
      data-testid="error-cross-icon-wrapper"
    >
      <img src={ErrorCrossIconSvg} alt="" />
    </ErrorCrossIconWrapper>
  );
};
